import { createContext, useState, useEffect } from "react";
import { v4 as uuidv4 } from "uuid";

const FeedbackContext = createContext();

export const FeedbackProvider = ({ children }) => {
  const [feedback, setFeedback] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    fetchFeedback();
  }, []);

  //fetch feedback
  const fetchFeedback = async () => {
    const response = await fetch(
      "https://feedbackjson.herokuapp.com/feedback?sort=id&order=desc"
    );
    const feedback = await response.json();
    setFeedback(feedback);
    setIsLoading(false);
  };

  const [feedbackEdit, setFeedbackEdit] = useState({
    item: {},
    edit: false,
  });




  const handelAdd = async (newFeedback) => {
    const response = await fetch('https://feedbackjson.herokuapp.com/feedback', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(newFeedback),
    })

    const data = await response.json()

    setFeedback([data , ...feedback ]);
  };

  const handleDelete = async (id) => {
    if (window.confirm("are you sur you wanna delete this ")) {
      await fetch(`https://feedbackjson.herokuapp.com/feedback/${id}`, { method: 'DELETE' })

      setFeedback(feedback.filter((item) => item.id !== id))
    }
  }


  const handleUpdate = async (id, updItem) => {
    const response = await fetch(`https://feedbackjson.herokuapp.com/feedback/${id}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(updItem),
    })

    const data = await response.json()

    // NOTE: no need to spread data and item
    setFeedback(feedback.map((item) => (item.id === id ? data : item)))

  };

  const handleEdit = (item) => {
    setFeedbackEdit({ item, edit: true });
  };

  return (
    <FeedbackContext.Provider
      value={{
        feedback,
        handleDelete,
        handelAdd,
        handleEdit,
        feedbackEdit,
        handleUpdate,
        isLoading,
      }}
    >
      {children}
    </FeedbackContext.Provider>
  );
};
export default FeedbackContext;
